import type { TaskEither } from 'fp-ts/lib/TaskEither';
import { fetchTE } from 'utils/request';

export const deleteOrgTE = <E = CF.API.ApiError>(
  {
    organization,
  }: {
    params?: string;
    organization: Pick<CF.API.Organizations.Organization, 'id'>;
  },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.BaseResponse> =>
  fetchTE<CF.API.BaseResponse, E>(
    {
      path: `/api/_api/v2/organizations/${organization.id}`,
      method: 'DELETE',
    },
    onRejected,
  );

export const leaveOrgTE = <E = CF.API.ApiError>(
  {
    organization,
  }: {
    params?: string;
    organization: Pick<CF.API.Organizations.Organization, 'id'>;
  },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.BaseResponse> =>
  fetchTE<CF.API.BaseResponse, E>(
    {
      path: `/api/_api/v2/organizations/${organization.id}/leave`,
      method: 'DELETE',
    },
    onRejected,
  );
